import type { AnalyticsSettings } from './types';

export const settingsContainValidTrackingEnabledOption = <
  S extends Partial<AnalyticsSettings> | undefined,
>(
  settings: S,
): settings is S & { trackingEnabled: boolean } =>
  settings && 'trackingEnabled' in settings && typeof settings.trackingEnabled === 'boolean';

export const settingsContainValidDebuggingEnabledOption = <
  S extends Partial<AnalyticsSettings> | undefined,
>(
  settings: S,
): settings is S & { debuggingEnabled: boolean } =>
  settings && 'debuggingEnabled' in settings && typeof settings.debuggingEnabled === 'boolean';
